import { Button, Checkbox, Tooltip } from '@fluentui/react-components';
import { CopyRegular, DeleteRegular } from '@fluentui/react-icons';

import type { TFieldSettings } from '../templateField/fieldSettings';

type TProps = {
  required: boolean;
  onSettingsChange: (patch: Partial<TFieldSettings>) => void;
  onDuplicate: () => void;
  onDelete: () => void;
};

const FormFieldCardFooter = ({ required, onSettingsChange, onDuplicate, onDelete }: TProps) => (
  <div
    contentEditable={false}
    className="flex items-center gap-1 rounded-b-md border-t border-neutralStroke-2 bg-neutralBg-2 px-2 py-1"
  >
    <Checkbox
      checked={required}
      label="Required"
      onChange={(_, data) => onSettingsChange({ required: data.checked === true })}
    />
    <div className="grow" />
    <Tooltip content="Duplicate field" relationship="label" withArrow>
      <Button appearance="subtle" icon={<CopyRegular />} onClick={onDuplicate} />
    </Tooltip>
    <Tooltip content="Delete field" relationship="label" withArrow>
      <Button appearance="subtle" icon={<DeleteRegular />} onClick={onDelete} />
    </Tooltip>
  </div>
);

export default FormFieldCardFooter;
